import api from '../baseAPIs/shopify';
import { Settings } from '@extTypes/settings/settings';

export const getSettings = async (store: string): Promise<Settings.Settings> => {
    const response = await api.get('settings/private', {
        params: {
            shop: store
        }
    });
    return response.data;
};

export const saveSettings = async (settings: Settings.Settings, shop: string, versioning = true) => {
    const response = await api.post('settings', settings, {
        params: {
            shop,
            versioning
        }
    });
    return response.data;
};

export const isEmailConfirmed = async (store: string): Promise<{ confirmed: boolean }> => {
    const response = await api.post('settings/email/check', null, {
        params: {
            shop: store
        }
    });
    return response.data;
};

export const hasTooltipType = async (
    type: Settings.TooltipType,
    operation: 'any' | 'all' = 'any'
): Promise<{ matches: boolean }> => {
    const response = await api.get('settings/tooltipType', {
        params: {
            type: type,
            operation: operation
        }
    });
    return response.data;
};
